export const QUICK_ADD = {
                            allowed_roles_add_team: [
                                                        "client_admin",
                                                        "account_owner",
                                                        "Administrator"
                                                    ]
                         }      